/**
 * Cross-cutting constants for the landing app.
 *
 * SPARROW_URL points at the real engine. In prod this is sparrow.dasc.nl;
 * override via VITE_SPARROW_URL at build time if you ever want the
 * "Open in Sparrow" CTAs to target a local dev server.
 *
 * NOTE on the CTA: Sparrow does not currently expose a "load this URL
 * as a dataset" hook. Its only URL-driven loading paths are
 *   1. `#share=<32-hex>` — a portal-minted capability token that
 *      expects the .sav file to arrive separately (a "you've been
 *      shared a file" flow, not a "fetch from URL" flow).
 *   2. PWA launchQueue — files double-clicked in the OS file manager
 *      after Sparrow is installed as a PWA.
 *   3. `?share-target=1` — the Web Share Target API receiver.
 * None of those let a third-party landing page hand Sparrow a CSV
 * by URL. So our CTA strategy is: trigger a CSV download in the
 * user's browser, then open Sparrow in a new tab with a small
 * instruction "drop the file you just downloaded here". If/when
 * Sparrow adds a `#load=<url>` hook upstream, we can drop the
 * download step and pass the URL directly.
 */

export const SPARROW_URL: string =
  (import.meta.env.VITE_SPARROW_URL as string | undefined) ??
  "https://sparrow.dasc.nl/"
